import { useState, useEffect } from "react";
import { RootState } from "../store/store";
import { useAppSelector } from "./hooks";

type Branch = {
    id: string;
    name: string;
  };
const useBranchId = ( branchesList: any[]) => {
  const [branchId, setBranchId] = useState<string | null>(null);
  const roleType = useAppSelector((state: RootState) => state.session.role_type);

  useEffect(() => {
    if (roleType === "company_admin") {
      if (branchesList.length > 1) {
      setBranchId("all_branches");
      } else if (branchesList.length === 1) {
        setBranchId(branchesList[0].id);
      }
    } else if (branchesList.length > 0) {
        setBranchId(branchesList[0].id)
    }
  }, [roleType, branchesList]);

  return { branchId, setBranchId };
};

export default useBranchId;
